export default {
  accepted: 'Принято',
  accessRequestDate: 'Дата запроса доступа',
  confirmUserWillBeSystemAdmin: 'Пользователь станет системным администратором. Продолжить?',
  copyInvitationLink: 'Скопировать ссылку-приглашение в буфер обмена',
  copyInvitationLinkConfirmMessage: `Если приглашенный пользователь не получил никаких писем на адрес {{email}},
вы можете скопировать ссылку-приглашение в буфер обмена и поделиться ею с ним другими способами.

Скопировать ссылку-приглашение в буфер обмена?`,
  copyPasswordResetLink: 'Скопировать ссылку для сброса пароля в буфер обмена?',
  copyPasswordResetLinkConfirmMessage: `Если пользователь сбросил свой пароль, но не получил никаких писем на адрес {{email}},
вы можете скопировать ссылку для сброса пароля в буфер обмена и поделиться ею с ним другими способами.

Скопировать ссылку для сброса пароля в буфер обмена?`,
  editSurveyUserExtraPropsForUser:
    'Редактировать дополнительные свойства пользователя опроса для пользователя "{{userName}}"',
  inviteUser: 'Пригласить',
  invitationExpiredClickToSendAgainTheInvitation: 'Приглашение истекло: нажмите, чтобы отправить приглашение снова',
  invitationLinkCopiedToClipboard: 'Ссылка-приглашение скопирована в буфер обмена',
  invitedBy: 'Приглашен(а) кем',
  invitedDate: 'Дата приглашения',
  lastLogin: 'Последний вход',
  moreThan30DaysAgo: 'Более 30 дней назад',
  notAcceptedYet: 'Приглашение еще не принято',
  passwordResetLinkCopiedToClipboard: 'Ссылка для сброса пароля скопирована в буфер обмена',
  passwordResetLink: 'Ссылка для сброса пароля',
  prefs: {
    title: 'Настройки уведомлений',
    notifyOnUserAccessRequest: 'Новые запросы на доступ',
  },
  roleInCurrentSurvey: 'Роль в текущем опросе',
  roleInSurvey: 'Роль в опросе',
  filterPlaceholder: 'Фильтровать по имени или email',
  surveyName: 'Название опроса',
  surveyExtraProp: {
    label: 'Дополнительное свойство опроса',
    label_other: 'Дополнительные свойства опроса',
  },
  surveysDraft: 'Опросы (черновик)',
  surveysPublished: 'Опросы (опубликовано)',
  userRemovedFromSurveyGoToSurveysRequired: `Вы были удалены из этого опроса.  
Нажмите «Перейти к опросам», чтобы открыть список опросов.`,
  userRoleUpdatedRefreshRequired: `Ваша роль в этом опросе была обновлена.  
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'Новая группа',
    edit: 'Редактировать группу',
    name: 'Название',
    label: 'Метка',
    qualifier: 'Квалификатор {{index}}',
    qualifier_plural: 'Квалификаторы',
    qualifierKey: 'Ключ',
    qualifierValue: 'Значение',
    addQualifier: 'Добавить квалификатор',
    members: 'Участники',
    addMember: 'Добавить участника',
    noMembers: 'Пока нет участников',
    memberAlreadyInGroup: 'В настоящее время в "{{groupName}}"',
    tabs: {
      groups: 'Группы пользователей',
      assignments: 'Распределение по группам',
      report: 'Отчёт по участникам',
    },
    memberName: 'Имя участника',
    memberEmail: 'Email участника',
    memberRole: 'Роль в опросе',
    memberStatus: 'Статус',
    status: {
      INVITED: 'Приглашен',
      ACCEPTED: 'Принято',
      FORCE_CHANGE_PASSWORD: 'Требуется смена пароля',
    },
    unassigned: 'Не назначено',
    confirmDelete: 'Удалить группу "{{name}}"? Ее участники станут неназначенными. Продолжить?',
    deleteConfirmed: 'Группа "{{name}}" была удалена',
    saveConfirmed: 'Группа "{{name}}" была сохранена',
    confirmReassign: '{{userName}} в настоящее время находится в группе "{{groupName}}". Переместить его в эту группу?',
    notFound: 'Группа не найдена',
  },
  updateUserConfirmation: 'Пользователь {{name}} обновлен',
  userNotInvitedToAnySurvey: `Пользователь не приглашен ни в один опрос`,
  userSurveys: 'Опросы пользователя',
  usersBackup: {
    menu: 'Резервное копирование / Восстановление',
    backup: 'Резервная копия пользователей',
    backupTitle: 'Резервная копия пользователей',
    backupInfo:
      'Все пользователи будут экспортированы вместе с их ролями в опросах и группами пользователей, чтобы их можно было восстановить на другом сервере Arena. Устройства 2FA не экспортируются.',
    includePasswords: 'Включить пароли',
    passwordsWarning:
      'Файл резервной копии будет содержать хеши паролей: храните его в надежном месте и удалите после использования.',
    restore: 'Восстановить пользователей',
    restoreTitle: 'Восстановление пользователей из резервной копии',
    restoreInfo: `- Пользователи сопоставляются по адресу электронной почты
- Роли в опросах и группы пользователей сопоставляются по названию опроса и названию группы
- Роли и группы пользователей в опросах, отсутствующих на этом сервере, игнорируются
- После нажатия «Восстановить пользователей» вы сможете выбрать действие для каждого пользователя`,
    backupFileInfo: 'Резервная копия создана {{email}} {{date}} (сервер: {{serverUrl}})',
    passwordsNotIncluded: 'Пароли не включены в эту резервную копию: новым пользователям нужно будет сбросить пароль',
    allNewUsers: 'Все новые пользователи ({{count}})',
    allExistingUsers: 'Все существующие пользователи ({{count}})',
    userStatus: 'Статус',
    userActionHeader: 'Действие',
    userNew: 'Новый',
    userExisting: 'Существующий',
    userAction: {
      insert: 'Добавить',
      skip: 'Пропустить',
      updateRoles: 'Обновить роли в опросах',
      updateAll: 'Обновить роли в опросах и данные',
    },
    sysAdmin: 'Сист. админ',
    restorePassword: 'Пароль',
    restorePasswordInfo:
      'Восстановить пароль из резервной копии (только при добавлении пользователя или обновлении его данных)',
    userActionShort: {
      insert: 'Добавить',
      skip: 'Пропустить',
      updateRoles: 'Роли',
      updateAll: 'Роли + данные',
    },
    details: {
      survey: 'Опрос',
      roleInBackup: 'Роль в резервной копии',
      currentRole: 'Текущая роль',
      notFoundInThisServer: '(не найдено на этом сервере)',
      userGroup: 'Группа пользователей',
      inBackup: 'В резервной копии',
      currentMember: 'Текущий участник',
    },
    summaryImported: 'Пользователи восстановлены',
    summary: {
      usersTotal: 'Пользователей в резервной копии: {{count}}',
      usersInserted: 'Новых пользователей: {{count}}',
      usersUpdated: 'Обновленных пользователей: {{count}}',
      usersSkipped: 'Пропущенных пользователей: {{count}}',
      authGroupsAdded: 'Добавлено ролей в опросах: {{count}}',
      userGroupsAdded: 'Добавлено членств в группах пользователей: {{count}}',
    },
    surveysNotFound: 'Опросы не найдены (роли проигнорированы): {{names}}',
    userGroupsNotFound: 'Группы пользователей не найдены (членство проигнорировано): {{names}}',
  },
}
